// Deployment configuration
// Update this file with each successful deployment

export const deploymentConfig = {
  lastDeploymentDate: "07/04/2026",
  lastBuildJob: "15",
  lastDeploymentTimestamp: "2026-07-04T19:45:00.000000+00:00",
  llmModel: "Claude Opus 4.8 (us.anthropic.claude-opus-4-8) — Certi tab remains on Opus 4.6 (legacy Bedrock KB)",
  version: "1.1.1"
};

export default deploymentConfig;
// Opus 4.8 standardization 2026-07-02 (was mixed 4.6/4.7)
